import PropTypes from "prop-types";
import React from "react";
import { components } from "react-select";
import { Badge } from "reactstrap";

const MenuColorSelect = ({ children, ...rest }) => {
  return (
    <React.Fragment>
      {/* @ts-ignore */}
      <components.Option {...rest}>
        <div className="d-flex justify-content-between align-items-center">
          <div>{children}</div>
          <Badge color={rest.value}>
            <div style={{ color: "transparent" }}>{"-----"}</div>
          </Badge>
        </div>
      </components.Option>
    </React.Fragment>
  );
};

MenuColorSelect.propTypes = {
  selectProps: PropTypes.any,
  children: PropTypes.any,
  options: PropTypes.any,
  value: PropTypes.any,
};

export default MenuColorSelect;
